const MAX_MOBILE_WIDTH = 599;

export const isMobile = (state) => {
  return state.ui.width <= MAX_MOBILE_WIDTH;
};

export const isFirstLoadCompleted = (state) => {
  return state.ui.firstLoadCompleted;
};
